import {pairPlayerWithRoom} from './firebase-rooms.js'
import {setMatchmakingValue} from '../../redux-actions/battle-actions.js'

/** What we do with player's userData when we set it or receive it from the server. */
export async function handleUserDataReceived() {
  //Do something with it

  //console.log('user data received!', userData);

  //Save our user data locally
  setMatchmakingValue({
    userDataState: "Success",
  });

  //We're ready to
  pairPlayerWithRoom();
}



// WEBPACK FOOTER //
// ./src/battle/connection/handle-user-data-received.js